import { Badge, Box, List, ListItemButton, ListItemText, Stack, Typography, alpha } from "@mui/material"
import { ERROR_COLOR, GREY, INFO_COLOR, MAIN_COLOR, SECONDARY_COLOR, WARN_COLOR, WHITE } from "../style/theme";
import { UListItemButton } from "../common/ui.buttons";
import { UIcon } from "../common/ui.icon";
import { URow } from "../common/ui.page";
import { CUnitBox, CUnitBoxName, CUnitCompText, CUnitShowDetailsButton } from "./cr.ui.unit";
import { createContext, useState } from "react";
import { gradient } from "../common/ui.gradient";
import { UNIT_SORT, UNIT_XP_PERC } from "./unit";


export function CMainField(props) {
    const { title, children, color } = props;

    return <Stack sx={{ flex: 1 }} alignItems="center">
        <Typography sx={{ color: MAIN_COLOR }}>{title}</Typography>
        <Typography sx={{ fontSize: 24, fontWeight: 600, color }}>{children}</Typography>
    </Stack>
}

export function CUnitSelection(props) {
    const { units, limit, remaining, selected, setSelected, color1, color2, ...rest } = props;
    var pts = 0;
    var cp = 0;
    selected.forEach(u => {
        pts += u.pts;
        cp += u.cp;
    })

    function doClick(u) {
        const isSelected = selected.filter(s => s.id === u.id).length > 0;
        if (isSelected) {
            setSelected(selected.filter(s => s.id !== u.id))
        } else {
            setSelected([...selected, u])
        }
    }

    return <CUnitListContainer {...rest}>
        <CUnitListHead color={color1} />
        <List>
            {units.sort(UNIT_SORT).map(u => <CUnitToSelect
                color1={color1}
                color2={color2}
                onClick={() => doClick(u)}
                selected={selected.filter(s => s.id === u.id).length > 0}
                unit={u}
                key={u.id} />)}
        </List>
        <CUnitListFooter color={color1} limit={limit} remaining={remaining} pts={pts} cp={cp} />
    </CUnitListContainer>

}
function CUnitToSelect(props) {
    const { unit, color1, color2, ...rest } = props;


    return <CUnitBox
        color1={color1}
        color2={color2}
        Component={UListItemButton}
        direction="row"
        unit={unit}
        sx={{
            marginBottom: 1,
        }}
        {...rest}>
        <Stack sx={{ flex: 1 }}>
            <Stack direction="row">
                <CUnitBoxName
                    unit={unit}
                />
                <CUnitListEndLine p1={unit.cp} p2={unit.pts} />
            </Stack>

            {false && <CUnitCompText className="secondary-text" sx={{ fontSize: 12, color: GREY[700], paddingTop: 1, fontWeight: 500 }} comp={unit.composition} />}

        </Stack>
    </CUnitBox>
}

export const CUnitListContext = createContext()
export function CUnitListContainer(props) {
    const [showDetails, setShowDetails] = useState(false)
    return <CUnitListContext.Provider value={{
        showDetails,
        setShowDetails,
    }}>
        <Stack {...props} />
    </CUnitListContext.Provider>
}

export function CUnitList(props) {
    const { units, limit, ...rest } = props;
    var pts = 0;
    var cp = 0;
    units.forEach(u => {
        pts += u.pts;
        cp += u.cp;
    })

    return <CUnitListContainer {...rest}>
        <CUnitListHead />
        <List>
            {units.sort(UNIT_SORT).map(u => <CUnit
                unit={u}
                key={u.id} />)}
        </List>
        <CUnitListFooter limit={limit} pts={pts} cp={cp} />
    </CUnitListContainer>

}

function CUnitListEndLine(props) {
    const { p1, p2 } = props;
    return <Stack direction="row" alignItems="center">
        <Typography sx={{ width: 40, lineHeight: 1 }}>{p1}</Typography>
        <Typography sx={{ width: 40, lineHeight: 1 }}>{p2}</Typography>
    </Stack>
}
function CUnitListHead(props) {
    const { color } = props;
    return <Stack direction="row" justifyContent="space-between"
        sx={{
            "*": { lineHeight: 1 },
            color: (color || GREY[700]),
            "*": { fontSize: 12, fontWeight: 500 },
            paddingLeft: 6
        }}>
        <Stack direction="row" spacing={2}>
            <Typography sx={{ lineHeight: 1 }}>Unità</Typography>
            <CUnitShowDetailsButton sx={{ lineHeight: 1 }} />
        </Stack>

        <CUnitListEndLine p1="Pc" p2="Pts" />
    </Stack>
}
function CUnitListFooter(props) {
    const { limit, remaining, pts, cp, color } = props;
    return <URow sx={{ color: color || GREY[700] }}>
        {limit > 0 && <Typography sx={{ fontSize: 12, fontWeight: 500, lineHeight: 1, color: pts > limit ? WARN_COLOR : '' }}>Punti {pts} / {limit}</Typography>}
        {limit < 0 && <Typography sx={{ fontSize: 12, fontWeight: 500, lineHeight: 1, color: remaining < 0 ? WARN_COLOR : '' }}>Punti rimanenti {remaining}</Typography>}

        <Typography sx={{ fontSize: 12, fontWeight: 500, lineHeight: 1 }}>Punti crociata: <font color={WHITE}>{cp}</font></Typography>
    </URow>
}
function CUnit(props) {
    const { unit, ...rest } = props;
    const percXp = UNIT_XP_PERC(unit.xp);

    const hasHonours = unit.unspentHonours > 0;
    const stlyeHonour = gradient([WARN_COLOR, SECONDARY_COLOR, INFO_COLOR])
    const additionalStyle = hasHonours ? stlyeHonour : {}
    const colorHonour = WARN_COLOR;

    return <CUnitBox
        percXp={hasHonours ? 0 : percXp}
        page={"unit/" + unit.id}
        Component={UListItemButton}
        direction="row"
        unit={unit}
        color1={hasHonours ? colorHonour : ''}
        sx={{
            marginBottom: 1,
            ...additionalStyle
        }}
        {...rest}>

        <Stack sx={{ flex: 1 }}>
            <Stack direction="row">
                <CUnitBoxName unit={unit}
                />
                <CUnitListEndLine p1={unit.cp} p2={unit.pts} />
            </Stack>

            {false && <CUnitCompText className="secondary-text" sx={{ fontSize: 12, color: GREY[700], paddingTop: 1, fontWeight: 500 }} comp={unit.composition} />}

        </Stack>
    </CUnitBox>
}